import axios from 'axios'
import CONSTANTS from '../../constants'

export default class fetchApiData {

  constructor() {
    if (sessionStorage.getItem("afficherPdvTest") !== null) {
      this.afficherPdvTest = sessionStorage.getItem("afficherPdvTest")
    }
    else {
      this.afficherPdvTest = '0'
    }
  }
  postSendFile(formData) {
    // if (process.env.NODE_ENV !== 'production') {
    //   // return axios.post(window.siteConfig.currentBrand === 'P' ? window.siteConfig.APIUploadFilePeugeot : window.siteConfig.currentBrand === 'C' ? window.siteConfig.APIUploadFileCitroen : "", formData, {
    //      return axios.post(window.siteConfig.rootPath + '/SCVUploadHandler.ashx', formData, {
    //       headers: {
    //       'content-type': 'multipart/form-data'
    //       //Authorization: 'Basic ' + btoa(process.env.PSAlogin + ':' + process.env.PSApass)
    //     },
    //     crossDomain: true,
    //     withCredentials: true
    //   }).then(this._handleResponse)
    // } else {
    return axios.post(window.siteConfig.rootPath + '/SCVUploadHandler.ashx', formData, {
      headers: {
        'content-type': 'multipart/form-data'
        //Authorization: 'Basic ' + btoa(process.env.PSAlogin + ':' + process.env.PSApass)
      },
      crossDomain: true,
      withCredentials: true
    }).then(this._handleResponse)
  }
  // }
  DeleteAttachment(encodedURL) {
    if (process.env.NODE_ENV !== 'production') {
      return axios.post(window.siteConfig.APIDeleteFile, {
        encodedURL: encodedURL,
      }, {
        headers: {
          Authorization: 'Basic ' + btoa(process.env.PSAlogin + ':' + process.env.PSApass)
        },
        crossDomain: true,
        withCredentials: true
      }).then(this._handleResponse)
    } else {
      return axios.post(window.siteConfig.APIDeleteFile, {
        encodedURL: encodedURL,
      }).then(this._handleResponse)
    }
  }

  getListDealers() {
    // if (process.env.NODE_ENV !== 'production') {
    //   return axios.get('/data/GetListDealer_copy.json')
    //     .then(this._handleResponse)

    // } else {
    return axios.post(window.siteConfig.APIListDealer, {
      dataForm: {
        Latitude: window.siteConfig.defaultCountryGeo.lat,
        Longitude: window.siteConfig.defaultCountryGeo.lng
      },
      afficherPdvTest: this.afficherPdvTest,
      cultureCode: CONSTANTS.SITE_INFO.CULTURE,
      brandCode: CONSTANTS.SITE_INFO.BRAND_CODE
    }).then(this._handleResponse)
    // }
    // }
  }

  getCalendar(iddealer, beginDate) {
    if (process.env.NODE_ENV !== 'production') {
      return axios.get('/data/getCallendar.json')
        .then(this._handleResponse)
    } else {
    return axios.post(window.siteConfig.APICalendar, {
      idDealer: iddealer,
      beginDate: beginDate,
      countDays: 4,
      brandCode: CONSTANTS.SITE_INFO.BRAND_CODE,
      afficherPdvTest: this.afficherPdvTest
    }).then(this._handleResponse)
    }
  }

  getImmatr(immaCode) {
    if (process.env.NODE_ENV !== 'production') {
      return axios.post(window.siteConfig.APIImmatriculation, {
        registration: immaCode,
        brandCodeP: CONSTANTS.SITE_INFO.BRAND_CODE,
        cultureCodeP: CONSTANTS.SITE_INFO.CULTURE
      }, {
        headers: {
          Authorization: 'Basic ' + btoa(process.env.PSAlogin + ':' + process.env.PSApass)
        },
        crossDomain: true,
        withCredentials: true
      }).then(this._handleResponse)
    } else {
      return axios.post(window.siteConfig.APIImmatriculation, {
        registration: immaCode,
        brandCodeP: CONSTANTS.SITE_INFO.BRAND_CODE,
        cultureCodeP: CONSTANTS.SITE_INFO.CULTURE
      }).then(this._handleResponse)
    }
  }

  getModels() {
    if (process.env.NODE_ENV !== 'production') {
      return axios.post(window.siteConfig.APIGetModels, {
        brandCodeP: CONSTANTS.SITE_INFO.BRAND_CODE,
        cultureCodeP: CONSTANTS.SITE_INFO.CULTURE
      }, {
        headers: {
          Authorization: 'Basic ' + btoa(process.env.PSAlogin + ':' + process.env.PSApass)
        },
        crossDomain: true,
        withCredentials: true
      }).then(this._handleResponse)
    } else {
      return axios.post(window.siteConfig.APIGetModels, {
        brandCodeP: CONSTANTS.SITE_INFO.BRAND_CODE,
        cultureCodeP: CONSTANTS.SITE_INFO.CULTURE
      }).then(this._handleResponse)
    }
  }

  getMotos(ModelCode) {
    if (process.env.NODE_ENV !== 'production') {
      return axios.post(window.siteConfig.APIGetMotos, {
        modelCode: ModelCode,
        brandCodeP: CONSTANTS.SITE_INFO.BRAND_CODE,
        cultureCodeP: CONSTANTS.SITE_INFO.CULTURE
      }, {
        headers: {
          Authorization: 'Basic ' + btoa(process.env.PSAlogin + ':' + process.env.PSApass)
        },
        crossDomain: true,
        withCredentials: true
      }).then(this._handleResponse)
    } else {
      return axios.post(window.siteConfig.APIGetMotos, {
        modelCode: ModelCode,
        brandCodeP: CONSTANTS.SITE_INFO.BRAND_CODE,
        cultureCodeP: CONSTANTS.SITE_INFO.CULTURE
      }).then(this._handleResponse)
    }
  }

  getCompagneRappelEligibility(serieCode) {
    if (process.env.NODE_ENV !== 'production') {
      // return axios.get('/data/checkCompagneRappel.json')
      return axios.post(window.siteConfig.APICampagneRappel, {
        SerialNumber: serieCode,
        cultureCode: CONSTANTS.SITE_INFO.CULTURE,
      }, {
        headers: {
          Authorization: 'Basic ' + btoa(process.env.PSAlogin + ':' + process.env.PSApass)
        },
        crossDomain: true,
        withCredentials: true
      })
        .then(this._handleResponse)
    } else {
      return axios.post(window.siteConfig.APICampagneRappel, {
        SerialNumber: serieCode,
        cultureCode: CONSTANTS.SITE_INFO.CULTURE,
      }).then(this._handleResponse)
    }
  }

  getSerie(serieCode) {
    if (process.env.NODE_ENV !== 'production') {
      // return axios.get('/data/getVehicleInfo.json')
      return axios.post(window.siteConfig.APISerieCode, {
        serialNumber: serieCode,
        brandCodeP: CONSTANTS.SITE_INFO.BRAND_CODE,
        cultureCodeP: CONSTANTS.SITE_INFO.CULTURE
      }, {
        headers: {
          Authorization: 'Basic ' + btoa(process.env.PSAlogin + ':' + process.env.PSApass)
        },
        crossDomain: true,
        withCredentials: true
      })
        .then(this._handleResponse)
    } else {
      return axios.post(window.siteConfig.APISerieCode, {
        serialNumber: serieCode,
        brandCodeP: CONSTANTS.SITE_INFO.BRAND_CODE,
        cultureCodeP: CONSTANTS.SITE_INFO.CULTURE
      }).then(this._handleResponse)
    }
  }

  getForfait(data) {
    if (process.env.NODE_ENV !== 'production') {
      return axios.post(window.siteConfig.APIGetForfait,
        {
          brandCode: CONSTANTS.SITE_INFO.BRAND_CODE,
          cultureCode: CONSTANTS.SITE_INFO.CULTURE,
          idDealer: Number(data.idDealer),
          serialNumber: data.serialNumber,
          modelCode: data.modelCode,
          motorCode: data.motorCode,
          lcdv: data.lcdv,
          energyLabel: data.energyLabel,
          mileage: Number(data.mileage),
          registration: data.registration,
          serviceContract: (!!data.serviceContract),
          afficherPdvTest: this.afficherPdvTest,
          dataFrom: 'B'
        }, {
        headers: {
          Authorization: 'Basic ' + btoa(process.env.PSAlogin + ':' + process.env.PSApass)
        },
        crossDomain: true,
        withCredentials: true
      }).then(this._handleResponse)
    } else {
      return axios.post(window.siteConfig.APIGetForfait, {
        brandCode: CONSTANTS.SITE_INFO.BRAND_CODE,
        cultureCode: CONSTANTS.SITE_INFO.CULTURE,
        idDealer: Number(data.idDealer),
        serialNumber: data.serialNumber,
        modelCode: data.modelCode,
        motorCode: data.motorCode,
        lcdv: data.lcdv,
        energyLabel: data.energyLabel,
        mileage: Number(data.mileage),
        registration: data.registration,
        serviceContract: (!!data.serviceContract),
        afficherPdvTest: this.afficherPdvTest,
        dataFrom: 'B'
      }).then(this._handleResponse)
    }
  }

  getPas(data) {
    if (process.env.NODE_ENV !== 'production') {
      return axios.post(window.siteConfig.APIGetPas, {
        idPV: data.geoID,
        afficherPdvTest: this.afficherPdvTest,
        cultureCode: CONSTANTS.SITE_INFO.CULTURE,
        brandCode: CONSTANTS.SITE_INFO.BRAND_CODE,
        mileage: data.mileage,
        vin: data.vin
      }, {
        headers: {
          Authorization: 'Basic ' + btoa(process.env.PSAlogin + ':' + process.env.PSApass)
        },
        crossDomain: true,
        withCredentials: true
      }).then(this._handleResponse)
    } else {
      return axios.post(window.siteConfig.APIGetPas, {
        idPV: data.geoID,
        afficherPdvTest: this.afficherPdvTest,
        cultureCode: CONSTANTS.SITE_INFO.CULTURE,
        brandCode: CONSTANTS.SITE_INFO.BRAND_CODE,
        mileage: data.mileage,
        vin: data.vin
      }).then(this._handleResponse)
    }
  }

  getForfaitEntretien(data) {
    if (process.env.NODE_ENV !== 'production') {
      return axios.post(window.siteConfig.APIGetForfaitEntretien, {
        pasCode: data.pasCode,
        cultureCode: CONSTANTS.SITE_INFO.CULTURE,
        brandCode: CONSTANTS.SITE_INFO.BRAND_CODE
      }, {
        headers: {
          Authorization: 'Basic ' + btoa(process.env.PSAlogin + ':' + process.env.PSApass)
        },
        crossDomain: true,
        withCredentials: true
      }).then(this._handleResponse)
    } else {
      return axios.post(window.siteConfig.APIGetForfaitEntretien, {
        pasCode: data.pasCode,
        cultureCode: CONSTANTS.SITE_INFO.CULTURE,
        brandCode: CONSTANTS.SITE_INFO.BRAND_CODE
      }).then(this._handleResponse)
    }
  }
  getServicePremium() {
    if (process.env.NODE_ENV !== 'production') {
      // return axios.get('/data/getPremiumServices.json')
      return axios.post(window.siteConfig.APIGetServicePremium, {

        cultureCode: CONSTANTS.SITE_INFO.CULTURE,
        brandCode: CONSTANTS.SITE_INFO.BRAND_CODE
      }, {
        headers: {
          Authorization: 'Basic ' + btoa(process.env.PSAlogin + ':' + process.env.PSApass)
        },
        crossDomain: true,
        withCredentials: true
      })
        .then(this._handleResponse)
    } else {
      return axios.post(window.siteConfig.APIGetServicePremium, {
        cultureCode: CONSTANTS.SITE_INFO.CULTURE,
        brandCode: CONSTANTS.SITE_INFO.BRAND_CODE
      }).then(this._handleResponse)
    }
  }
  getClientBasket(data) {
    if (process.env.NODE_ENV !== 'production') {
      return axios.post(window.siteConfig.APIGetBasket, {
        id: data.basketId,
        keyModif: data.keyModif,
        culture: CONSTANTS.SITE_INFO.CULTURE,
        brand: CONSTANTS.SITE_INFO.BRAND_CODE,
        afficherPdvTest: this.afficherPdvTest,
        dataFrom: 'B'
      }, {
        headers: {
          Authorization: 'Basic ' + btoa(process.env.PSAlogin + ':' + process.env.PSApass)
        },
        crossDomain: true,
        withCredentials: true
      }).then(this._handleResponse)
    } else {
      return axios.post(window.siteConfig.APIGetBasket, {
        id: data.basketId,
        keyModif: data.keyModif,
        culture: CONSTANTS.SITE_INFO.CULTURE,
        brand: CONSTANTS.SITE_INFO.BRAND_CODE,
        afficherPdvTest: this.afficherPdvTest,
        dataFrom: 'B'
      }).then(this._handleResponse)
    }
  }

  confirmeRDVBasket(data, carStep, idRdvLead) {
    if (process.env.NODE_ENV !== 'production') {
      return axios.post(window.siteConfig.APIConfirmRDV, {
        cultureCode: CONSTANTS.SITE_INFO.CULTURE,
        brandCode: CONSTANTS.SITE_INFO.BRAND_CODE,
        dealerId: data.dealerInfos.iD,
        idRdvLeads: idRdvLead,
        afficherPdvTest: this.afficherPdvTest,
        selfReceptionChoice: data.personalInfos.premiumServiceSelfReception,
        // rdvDate: "20/05/2022 09:30",
        rdvDate: data.carDetails.date + ' ' + data.carDetails.hour,
        reduction: (Number(data.carDetails.happy) ? Number(data.carDetails.happy) : 0),
        RdvUpdated: (!!data.idRdv),
        basketId: data.idRdv || 0,
        codePas: carStep,
        listeInterventions: data.listeInterventions,
        listeServicePremium: data.listeServicePremium,
        customer: {
          CivilityCode: data.personalInfos.civilityCode,
          Firstname: data.personalInfos.firstname,
          Name: data.personalInfos.name,
          EMail: data.personalInfos.mail,
          Telephone: data.personalInfos.phone,
          ContactMode: data.personalInfos.contactMode,
          IsNeedMobilSolution: data.personalInfos.solutionMobilite,
          ConsentEmail: data.personalInfos.ConsentEmail,
          ConsentTel: data.personalInfos.ConsentTel,
          ConsentSms: data.personalInfos.ConsentSms,
          ConsentAddress: data.personalInfos.ConsentAddress,
          ConsentOther: data.personalInfos.ConsentOther,
          ConsentToAcceptCommercialChoice: data.personalInfos.ConsentToAcceptCommercialChoice,
          IsOfferCompanyAccepted: data.personalInfos.offerCompany,
          IsUsablePersonalInfo: data.personalInfos.offerCommercial,
          IsAcceptingLealMention: data.personalInfos.acceptLegalNotices,
          Origin: sessionStorage.getItem("origine"),
          ConsentMarketing : data.personalInfos.ConsentMarketing,
          ConsentProfiling : data.personalInfos.ConsentProfiling,
          ConsentThirdParty : data.personalInfos.ConsentThirdParty,
        },
        vehicleInfo: {
          Mileage: data.carDetails.kilometrage,
          SerialNumber: data.carDetails.SerialNumber,
          HasServiceContract: data.carDetails.contratService,
          BrandLabel: data.carDetails.BrandLabel,
          Lcdv: data.carDetails.Lcdv,
          ModelCode: data.carDetails.ModelCode,
          EnergyLabel: data.carDetails.EnergyLabel,
          ModelLabel: data.carDetails.ModelLabel,
          Registration: data.carDetails.Registration,
          MotorCode: data.carDetails.MotorCode,
          isOtherBrand: data.carDetails.BrandCode === 'O'
        },
        forfaitRefs: Object.values(data.selectedServices.forfaitRefs),
        subFunctionCodes: Object.values(data.selectedServices.subFunctionCodes),
        comment: data.selectedServices.comment,
        AttachmentID: data.AttachmentID,
        urlEncodedList: data.urlEncodedList || {},
        dataFrom: 'B',
        fromLink: false
      }, {
        headers: {
          Authorization: 'Basic ' + btoa(process.env.PSAlogin + ':' + process.env.PSApass)
        },
        crossDomain: true,
        withCredentials: true
      }).then(this._handleResponse)
    } else {
      return axios.post(window.siteConfig.APIConfirmRDV, {
        cultureCode: CONSTANTS.SITE_INFO.CULTURE,
        brandCode: CONSTANTS.SITE_INFO.BRAND_CODE,
        dealerId: data.dealerInfos.iD,
        idRdvLeads: idRdvLead,
        afficherPdvTest: this.afficherPdvTest,
        selfReceptionChoice: data.dealerInfos.SelfReception,
        rdvDate: data.carDetails.date + ' ' + data.carDetails.hour,
        reduction: (Number(data.carDetails.happy) ? Number(data.carDetails.happy) : 0),
        RdvUpdated: (!!data.idRdv),
        basketId: data.idRdv || 0,
        codePas: carStep || '',
        listeInterventions: data.listeInterventions,
        listeServicePremium: data.listeServicePremium,
        customer: {
          CivilityCode: data.personalInfos.civilityCode,
          Firstname: data.personalInfos.firstname,
          Name: data.personalInfos.name,
          EMail: data.personalInfos.mail,
          Telephone: data.personalInfos.phone,
          ContactMode: data.personalInfos.contactMode,
          IsNeedMobilSolution: data.personalInfos.solutionMobilite,
          ConsentEmail: data.personalInfos.ConsentEmail,
          ConsentTel: data.personalInfos.ConsentTel,
          ConsentSms: data.personalInfos.ConsentSms,
          ConsentAddress: data.personalInfos.ConsentAddress,
          ConsentOther: data.personalInfos.ConsentOther,
          ConsentToAcceptCommercialChoice: data.personalInfos.ConsentToAcceptCommercialChoice,
          IsOfferCompanyAccepted: data.personalInfos.offerCompany,
          IsUsablePersonalInfo: data.personalInfos.offerCommercial,
          IsAcceptingLealMention: data.personalInfos.acceptLegalNotices,
          Origin: sessionStorage.getItem("origine"),
          ConsentMarketing : data.personalInfos.ConsentMarketing,
          ConsentProfiling : data.personalInfos.ConsentProfiling,
          ConsentThirdParty : data.personalInfos.ConsentThirdParty,
        },
        vehicleInfo: {
          Mileage: data.carDetails.kilometrage,
          SerialNumber: data.carDetails.SerialNumber,
          HasServiceContract: data.carDetails.contratService,
          BrandLabel: data.carDetails.BrandLabel,
          Lcdv: data.carDetails.Lcdv,
          ModelCode: data.carDetails.ModelCode,
          EnergyLabel: data.carDetails.EnergyLabel,
          ModelLabel: data.carDetails.ModelLabel,
          Registration: data.carDetails.Registration,
          MotorCode: data.carDetails.MotorCode,
          isOtherBrand: data.carDetails.BrandCode === 'O'
        },
        forfaitRefs: Object.values(data.selectedServices.forfaitRefs),
        subFunctionCodes: Object.values(data.selectedServices.subFunctionCodes),
        comment: data.selectedServices.comment,
        AttachmentID: data.AttachmentID,
        urlEncodedList: data.urlEncodedList || {},
        dataFrom: 'B',
        fromLink: false
      }).then(this._handleResponse)
    }
  }

  getBannerInfo(){
    return axios.post(window.siteConfig.APIBannerInfo, {
      cultureCode: CONSTANTS.SITE_INFO.CULTURE,
      brandCode: CONSTANTS.SITE_INFO.BRAND_CODE,
    }).then(this._handleResponse)
  }

  _handleResponse(response) {
    const contentType = response.headers['content-type']
    const isJSON = (contentType) && contentType.includes('application/json') || false
    if (response.statusText && isJSON && response.status == 200) {
      return response.data
    }

    return Promise.reject(new Error(response))
  }
}
